export default {
      id: "pay-premium-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#pay-premium",
      toString: function () {
        return this.url;
      }
    }